import { createSlice } from "@reduxjs/toolkit";
import { matchesLibrarySave } from "../library/libraryState";

const initialState = {
    activeStep: 0,
    uploadedFiles: [],
    uploadedFileRes: [],
    loading: false,
    analysisReport: null,
    analysisLibrary: null,
    isEmbeddingLoading: false,
    isReportLoading: false,
};

export const qualitativeAnalysisSlice = createSlice({
    name: "qualitativeAnalysis",
    initialState,
    reducers: {
        setActiveStep: (state, action) => {
            state.activeStep = action.payload;
        },
        nextStep: (state) => {
            state.activeStep += 1;
        },
        previousStep: (state) => {
            state.activeStep -= 1;
        },
        resetStep: (state) => {
            state.activeStep = 0;
        },

        addUploadedFiles: (state, action) => {
            state.uploadedFiles = [
                ...state.uploadedFiles,
                ...action.payload.map((file) => ({
                    name: file.name,
                    size: file.size,
                    type: file.type,
                })),
            ];
        },
        addUploadedFileRes: (state, action) => {
            state.uploadedFileRes = [...state.uploadedFileRes, ...action.payload];
        },
        setIsEmbeddingLoading: (state, action) => {
            state.isEmbeddingLoading = action.payload;
        },
        setIsReportLoading: (state, action) => {
            state.isReportLoading = action.payload;
        },
        setQualitativeLoadingState: (state, action) => {
            const { isEmbeddingLoading, isReportLoading } = action.payload;
            state.isEmbeddingLoading = isEmbeddingLoading ?? state.isEmbeddingLoading;
            state.isReportLoading = isReportLoading ?? state.isReportLoading;
        },
        removeUploadedFile: (state, action) => {
            const index = action.payload;
            const fileToRemove = state.uploadedFiles[index];
            state.uploadedFiles = state.uploadedFiles.filter(
                (_, i) => i !== index
            );
            state.uploadedFileRes = state.uploadedFileRes.filter(
                (res) => !res.includes(fileToRemove.name)
            );
        },
        clearUploadedData: (state) => {
            state.uploadedFiles = [];
            state.uploadedFileRes = [];
        },

        setLoading: (state, action) => {
            state.loading = action.payload;
        },
        setAnalysisReport: (state, action) => {
            state.analysisReport = action.payload?.url ?? action.payload;
            state.analysisLibrary = action.payload?.library || null;
        },
        clearAnalysisReport: (state) => {
            state.analysisLibrary = null;
            state.analysisReport = null;
        },
        resetQualitativeState: () => initialState,
    },
    extraReducers: (builder) => {
        builder.addCase("library/saveConfirmed", (state, action) => {
            if (matchesLibrarySave(state.analysisLibrary, action)) state.analysisLibrary = action.payload;
        });
    },
});

export const {
    setActiveStep,
    nextStep,
    previousStep,
    resetStep,
    addUploadedFiles,
    addUploadedFileRes,
    removeUploadedFile,
    clearUploadedData,
    setLoading,
    setAnalysisReport,
    clearAnalysisReport,
    resetQualitativeState,
    setIsEmbeddingLoading,
    setIsReportLoading,
    setQualitativeLoadingState,
} = qualitativeAnalysisSlice.actions;

export default qualitativeAnalysisSlice.reducer;
